

module.exports = __webpack_require__.stylable.create(
    "LockedIcon1759009882",
    {"classes":{"root":"LockedIcon1759009882__root","rootCircle":"LockedIcon1759009882__rootCircle"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "LockedIcon1759009882",
    null
);
